<script setup lang="ts">
  import { useFormField } from '@/composables/useFormField'
  import CheckboxField from '@/components/admin/form/CheckboxField.vue'
  import { useFieldValidation } from '@/composables/useQuestionnaire'

  const props = defineProps({
    field: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    isPreviewMode: {
      type: Boolean,
      default: false
    }
  })

  const emit = defineEmits(['update:modelValue', 'validation-error'])

  const { selectedValue } = useFormField(props)

  const { validationError, handleInputChange } = useFieldValidation(props, emit)

  const isSelected = (option: any) => {
    return selectedValue.value.includes(option)
  }

  const handleOptionChange = (value: boolean, option: any) => {
    if (props.isPreviewMode) return
    if (value) {
      if (!selectedValue.value.includes(option)) {
        selectedValue.value.push(option)
      }
    } else {
      const index = selectedValue.value.indexOf(option)
      if (index > -1) {
        selectedValue.value.splice(index, 1)
      }
    }
    handleInputChange(selectedValue.value)
  }
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-for="(option, key) in props.field.choices"
      :key="key"
      class="flex items-center gap-2 rounded-lg p-2 transition-colors"
      :class="[
        isSelected(option) ? 'bg-gray-50' : 'bg-white',
        isPreviewMode ? 'cursor-default opacity-60' : 'cursor-pointer'
      ]"
    >
      <CheckboxField
        :name="`${props.field.id}-${key}`"
        :label="option"
        :model-value="isSelected(option)"
        :checked-value="true"
        :unchecked-value="false"
        :disabled="isPreviewMode"
        class="flex-1"
        :data-cy="`CheckBoxV3Checkbox-${field.uuid}-${key}`"
        @update:model-value="(value) => handleOptionChange(value, option)"
      />
    </div>
    <!-- Validation error message -->
    <div
      v-if="validationError"
      class="mt-1 text-sm text-red-600"
    >
      {{ validationError }}
    </div>
  </div>
</template>
